module.exports = function(h, row) {
    return row.parent == null ? <i>No Parent Assigned</i> : row.parent;
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/item/parent.jsx